// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from "firebase/compat/app";
import "firebase/compat/auth"; // for authentication

const firebaseConfig = {
  apiKey: "AIzaSyAQTJa50nzPeX1-PbRcd9uUiBjngpBqlmA",
  authDomain: "akportfolio-78cdf.firebaseapp.com",
  projectId: "akportfolio-78cdf",
  storageBucket: "akportfolio-78cdf.appspot.com",
  messagingSenderId: "146713078361",
  appId: "1:146713078361:web:9481250ae88b0748151f48",
  measurementId: "G-DWX23F2PQ8",
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
export { firebaseApp, auth, provider };
